module.exports = __webpack_public_path__ + "static/media/help_tasks.a921fda3.png";